// Norwegian Bokmal
// Norwegian Bokmål

const lang = {
  gateMediaPreviewHeader: 'Kan hende du også liker',
  loadmore: 'Vis mer',
  nextMedia: 'Neste medier',
  previousMedia: 'Forrige medier',
  closePost: 'Lukk innlegg',
  nextPost: 'Neste innlegg',
  previousPost: 'Forrige innlegg',
  outOfStock: 'Utsolgt',
  numberOfReviews(n) {
    return n === 1 ? 'anmeldelse' : 'anmeldelser'
  },
  reportFormField: 'Vennligst skriv inn en melding',
  reportPost: 'Rapporter innlegg',
  reportFormTitle: 'Vil du rapportere dette bildet?',
  reportFormDetails:
    'Hvis du tror at dette bildet er upassende, ulovlig eller krenker andres rettigheter, kan du rapportere innholdet. Hvis du rapporterer bildet/teksten, vil innholdsmoderatorene bli varslet og riktige tiltak iverksatt.',
  reportFormMessagePlaceholder: 'Oppgi årsaken til rapporten din',
  reportFormMessageLabel: 'Melding',
  reportFormEmailLabel: 'Din e-post',
  reportFormSubmitButtonText: 'Send rapport',
  reportFormCancelButtonText: 'Avbryt',
  reportFormSentTitle: 'Takk for din rapport!',
  reportFormSentCloseButtonText: 'Lukk',
  cardAndTileAriaLabel: 'Liste over innlegg fra kontoer på ulike sosiale medieplattformer',
  carouselAriaLabel: 'Karusell med innlegg fra kontoer på ulike sosiale medieplattformer',
  singleAriaLabel: 'Nedenfor er et innlegg fra en konto på sosiale medier',
  poweredBy: 'Drevet av Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publisert på ${date}` : ''
    const createdByString = userName ? ` fra ${userName}` : ''
    return `Bilde${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Last opp media',
  openTheGate: 'Åpne dialogboksen',
  gridRoleDescription: 'rutenett',
  carouselRoleDescription: 'karusell',
  tiktokVideoAriaLabel: 'Innebygd TikTok-video. Trykk på spill for å se innholdet.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Minibilde av media ${postIndex + 1} av ${maxPosts}, åpner dialog med sosiale medier-innhold og fremhevet produktliste.`,
  carouselControlButtonsAriaLabel: 'Kontrollknapper for karusell',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `Media ${mediaIndex + 1} av ${maxMedia}`,
  showMoreCaption: 'Vis mer bildetekst',
  showLessCaption: 'Vis mindre bildetekst',
  originalPrice: (price) => `Originalpris: ${price}`,
  salesPrice: (price) => `Salgspris: ${price}`,
  postPublishedBy: 'Innlegg publisert av',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Video' : 'Bilde'
    const user = username ? `${username}` : 'ukjent bruker'
    const publishDate = date ? `den ${date}` : ''
    return `${mediaType} lagt ut av ${user} ${publishDate}. Det kan være ${altText}`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Innlegg ${postIndex + 1} av ${maxPosts}.`,
}

export default lang
